import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItinerariosRoutingModule } from './itinerarios-routing.module';
import { ItinerariosComponent } from './itinerarios.component';
import { ItinerarioDetalleComponent } from './detail/itinerario-detalle.component';

@NgModule({
  imports: [
    CommonModule,
    ItinerariosRoutingModule,
    ItinerariosComponent,
    ItinerarioDetalleComponent
  ]
})
export class ItinerariosModule { }
